import { guid } from '@fry/lib/utils';


export abstract class EditorEligibilityRule {
  id: string;

  abstract className: string;
  abstract operatorName: string;

  abstract createCopy(): EditorEligibilityRule;
  abstract getControlsConfig(): { [key: string]: any; };
  abstract getSerializedValues(): any;

  protected constructor(obj?: any) {
    this.id = obj?.id ?? null;
  }

  createClone(): EditorEligibilityRule {
    const clonedOperator = this.createCopy();
    clonedOperator.id = guid();
    return clonedOperator;
  }
}
